(() => {
  'use strict';
  const installed = new WeakSet();
  const install = root => root.querySelectorAll('form[data-pd-cart-form]').forEach(form => {
    if (installed.has(form) || form.closest('product-form') || form.hasAttribute('data-preview')) return;
    installed.add(form);
    let pending = false;
    const notice = form.querySelector('[data-pd-cart-error]');
    const message = form.querySelector('[data-pd-cart-message]');
    const buttons = Array.from(form.querySelectorAll('[type="submit"]'));
    form.addEventListener('submit', async event => {
      if (event.defaultPrevented) return;
      event.preventDefault();
      if (pending) return;
      if (!form.checkValidity()) { form.reportValidity(); return; }
      const route = new URL(window.Shopify.routes.root, location.origin);
      if (route.origin !== location.origin || !route.pathname.endsWith('/')) return;
      const body = new FormData(form);
      pending = true;
      buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
      notice.hidden = true;
      let knownRejection = false;
      try {
        const response = await fetch(new URL('cart/add.js', route).href, {
          method: 'POST', credentials: 'same-origin', body,
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
        });
        const result = await response.json();
        if (!response.ok) {
          knownRejection = response.status >= 400 && response.status < 500;
          message.textContent = typeof result.description === 'string' ? result.description : form.dataset.pdCartUnknown;
          notice.hidden = false;
          return;
        }
        let timer;
        try {
          await Promise.race([
            Promise.resolve().then(() => window.PrideDogsMail?.cartAddResponse(result)).catch(() => false),
            new Promise(resolve => { timer = setTimeout(resolve, 1000); })
          ]);
        } finally { clearTimeout(timer); }
        location.assign(new URL('cart', route).href);
      } catch {
        message.textContent = form.dataset.pdCartUnknown;
        notice.hidden = false;
      } finally {
        buttons.forEach(button => { button.removeAttribute('aria-busy'); button.disabled = !knownRejection; });
        if (knownRejection) pending = false;
      }
    });
  });
  install(document);
  document.addEventListener('shopify:section:load', event => install(event.target));
})();
